import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const good = {
  createGood: lazyModuleMethod(() => import('./createGood'), 'default'),
  createGoodLink: lazyModuleMethod(() => import('./createGoodLink'), 'default'),
  deleteGoodLink: lazyModuleMethod(() => import('./deleteGoodLink'), 'default'),
  updateGood: lazyModuleMethod(() => import('./updateGood'), 'default'),
  updateGoodLink: lazyModuleMethod(() => import('./updateGoodLink'), 'default'),
}
